import { LangE } from "../../../models/enums";

/**
 * Check if current language is included in notification Languages array
 * Languages: 0 = Hebrew, 1 = English
 * Languages field is required, so it will always have values
 * 
 * @param currentLang - Current language from LangE enum
 * @param languages - Array of language numbers from notification (0 = Hebrew, 1 = English)
 * @returns true if current language is included in languages array
 */
export const isLanguageMatched = (currentLang: LangE, languages: number[]): boolean => {
  // Map LangE to number: HE = 0, EN = 1
  const currentLangNumber = currentLang === LangE.HE ? 0 : 1;
  return languages.includes(currentLangNumber);
};

